import React from 'react';
import { ControlledRadioGroup } from 'src/components/BeaconV2Components/common/ControlledRadioGroup';
import { brandsCategories } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/constants';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import { isFieldVisible, getFieldConfig } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/constants/formConfigs';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { BrandSelectForBrandsStep } from './BrandSelectForBrandsStep';

export const PresentationsBrandsPage = () => {
  const {
    brands: { control },
    currentFormConfig
  } = usePresentationFormContext();

  const showBrandGroupings = isFieldVisible(currentFormConfig, 'brandGroupings');
  const brandIdsConfig = getFieldConfig(currentFormConfig, 'brandIds');
  
  // Brand selection is ALWAYS on Brands step (never on Selection step)
  // Show direct brand selection when: brandGroupings is hidden AND brandIds has minCount >= 1
  const brandSelectionRequired = (brandIdsConfig.minCount ?? 0) >= 1;
  const showDirectBrandSelection = !showBrandGroupings && brandSelectionRequired;

  // Show brand selection on Brands step
  if (showDirectBrandSelection) {
    return <BrandSelectForBrandsStep />;
  }

  // If brand groupings is hidden and no brand selection required
  if (!showBrandGroupings) {
    return (
      <Flex flexDirection="column" gap={16}>
        <Text variant="h4" lineHeight="28px">
          Brand Configuration
        </Text>
        <Text variant="body1" sx={{ color: 'text.secondary' }}>
          This presentation type does not require brand configuration.
          Continue to review your presentation settings.
        </Text>
      </Flex>
    );
  }

  // Default: Show the brand groupings radio options
  return (
    <ControlledRadioGroup
      control={control}
      name="brandGroupings"
      options={brandsCategories}
      label="Brand Highlights"
      description="This presentation will highlight additional insights for the brands selected below."
    />
  );
};
